<template>
  <Lottie id="map-france" class="animation" :options="mapAnimationOptions" />
</template>

<script>
import Lottie from 'chimera/all/components/Lottie'
import { getWithText } from 'chimera/all/assets/lottie/maps/france.js'

export default {
  name: 'MapFrance',

  components: {
    Lottie,
  },

  props: {
    text: {
      type: String,
      default: "a besoin d'un spécialiste.",
    },
  },

  computed: {
    /**
     *
     * @returns {{animationData: *}}
     */
    mapAnimationOptions() {
      return {
        animationData: getWithText(this.text),
      }
    },
  },
}
</script>
